import cx from 'classnames';
import React from 'react';

export interface LayoutGapProps {
	children: React.ReactNode;
	gap?: 'none' | 's' | 'm' | 'l' | 'xl' | '2xl' | '3xl';
	className?: string;
	asChild?: boolean;
}

export const LayoutGap = ({
	children,
	gap = 'l',
	className,
	asChild = false,
}: LayoutGapProps) => {
	const mergedClassName = cx(
		'flex flex-col',
		gap && `gap-(--templates-margin-${gap})`,
		className && className
	);

	const cloneWithMergedClassName = (child: React.ReactElement) => {
		const existing = (child.props as { className?: string }).className;
		return React.cloneElement(
			child as React.ReactElement<{ className?: string }>,
			{
				className: cx(existing, mergedClassName),
			}
		);
	};

	if (asChild) {
		// Expect a single React element; merge className into it
		if (React.isValidElement(children)) {
			return cloneWithMergedClassName(children as React.ReactElement);
		}
		// Fallback: if children is not a valid element, render a div to preserve layout
		return <div className={mergedClassName}>{children}</div>;
	}

	// Default wrapper rendering
	return <div className={mergedClassName}>{children}</div>;
};
